import { BsCaretLeftFill } from "react-icons/bs";
import { useWindowSize } from "../../hooks/useWindowSize";
import { OnCurtainStart } from "../../types/types";

const CaretAndBack = ({
  onCurtainStart,
  curtainTo,
}: {
  onCurtainStart: OnCurtainStart;
  curtainTo;
}) => {
  const { h } = useWindowSize();

  return (
    <div
      {...{
        id: "caret-and-back",
        style: {
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        },
        onClick: () => {
          // console.log({ onCurtainStart, curtainTo });
          onCurtainStart({ curtainTo });
        },
      }}
    >
      <BsCaretLeftFill
        {...{
          style: {
            fontSize: h(1.5),
          },
        }}
      />
      <div
        {...{
          style: {
            marginLeft: h(1),
            fontSize: h(1.75),
            fontWeight: 600,
            letterSpacing: h(0.1),
          },
        }}
      >
        BACK
      </div>
    </div>
  );
};

export { CaretAndBack };
